import React from "react";
import * as Yup from "yup";
import { CustomAlerts } from "@hedgefund/shared";
import { useFormik } from "formik";
import { Input, Button, Spinner } from "@public/ui-toolkit";

const PreviousMatrixForm = ({
  id,
  onSubmitPerformanceMatrix,
  message,
  loading,
  initialValues,
  yupObject,
  monthList,
}) => {
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object(yupObject),
    onSubmit: (values) => {
      const performanceMetrics = monthList.map((item, index) => {
        if (
          index ===
          Number(`${values.monthlyReturn}${index}`.replace(/[^0-9]/g, ""))
        ) {
          return {
            month: item,
            monthlyReturn: `${values[`monthlyReturn${index}`]}`,
          };
        }
      });
      onSubmitPerformanceMatrix({
        id: id,
        performanceMetrics: performanceMetrics,
      });
    },
  });

  return (
    <main>
      {message && !loading ? (
        <CustomAlerts
          alertMessage={"Request Successfully! Sent"}
          type="success"
        />
      ) : (
        ""
      )}
      <div className="main-inner ">
        <div className="container">
          {loading ? (
            <Spinner />
          ) : (
            <div
              className="
            edit-profile-container
            p-xxl-5 p-md-4 p-3
            box-shadow
            bg-white
            rounded-large
          "
            >
              <div className="box-lg mt-5">
                <div className="row">
                  <div className="heading text-center justify-content-center pb-5 ">
                    <h2 className="text-blue">Performance Metrix</h2>
                  </div>
                </div>

                <form onSubmit={formik.handleSubmit}>
                  <div className="mt-5">
                    {monthList &&
                      monthList?.length > 0 &&
                      monthList?.map((item, index) => {
                        return (
                          <div className="row g-4 mb-4">
                            <div className="col-md-4">
                              <Input
                                type="text"
                                placeholder="Month"
                                id="month"
                                label="Month"
                                forr="month"
                                disabled={"disabled"}
                                value={item}
                                props
                              />
                            </div>

                            <div className="col-md-4">
                              <div className="w-100 fund-select position-relative">
                                <Input
                                  type="number"
                                  placeholder="Monthly Return"
                                  id="monthlyReturn"
                                  label="Monthly Return"
                                  forr="monthlyReturn"
                                  {...formik.getFieldProps(
                                    `monthlyReturn${index}`
                                  )}
                                  props
                                />
                                {formik.touched[`monthlyReturn${index}`] &&
                                formik.errors[`monthlyReturn${index}`] ? (
                                  <div className="form-error-message">
                                    {formik.errors[`monthlyReturn${index}`]}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    <div className="text-right mt-5">
                      {monthList.length > 0 && (
                        <Button
                          btnName="Submit"
                          btnType="primary"
                          type="submit"
                          onClick={formik.handleSubmit}
                        />
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default PreviousMatrixForm;
